import { AuditModelDto } from '@treasury/api/channel';
import { CheckException } from '@treasury/domain/arp';
import usd from '@treasury/policy/lib/formatters/usd.formatter';
import { exists } from '@treasury/utils';

export class CheckExceptionVm {
    constructor(private _exception?: CheckException) {}

    public formatDate(dateStr?: Date | string): string {
        if (!exists(dateStr)) {
            return '';
        }
        const date = new Date(dateStr);
        if (date.toDateString() === 'Invalid Date') {
            return '';
        }
        return Intl.DateTimeFormat(undefined, {
            month: 'numeric',
            day: 'numeric',
            year: 'numeric',
        }).format(date);
    }

    public formatDateTime(dateStr?: Date | string) {
        if (!exists(dateStr)) {
            return '';
        }
        const date = new Date(dateStr);
        if (date.toDateString() === 'Invalid Date') {
            return '';
        }
        return `${this.formatDate(dateStr)} ${Intl.DateTimeFormat(undefined, {
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
        }).format(date)}`;
    }

    private get exception() {
        return (
            this._exception ?? {
                accountNumber: '',
                issuedPayee: '',
                paidAmount: 0,
                issuedAmount: 0,
                postedDate: '',
                issuedDate: '',
                protected: false,
                decidedToday: false,
                audits: [] as AuditModelDto[],
                isPastCutoff: false,
            }
        );
    }

    public get accountNumber() {
        return this.exception.accountNumber;
    }

    public get issuedPayee() {
        return this.exception.issuedPayee;
    }

    public get paidAmount() {
        return usd(this.exception?.paidAmount ?? 0) ?? '';
    }

    public get issuedAmount() {
        return usd(this.exception?.issuedAmount ?? 0) ?? '';
    }

    public get postedDate() {
        return this.formatDate(this.exception.postedDate) ?? '';
    }

    public get issuedDate() {
        return this.formatDate(this.exception.issuedDate) ?? '';
    }

    public get protected() {
        return this.exception.protected ? 'Yes' : 'No';
    }

    public get decidedToday() {
        return (
            this.exception.isPastCutoff ||
            // TODO: this would probably more performant with a .some instead
            this.exception?.audits?.reduce((prev: boolean, audit: AuditModelDto): boolean => {
                const yesterday = new Date();
                yesterday.setDate(yesterday.getDate() - 1);
                const sinceYesterday = new Date(audit.timestamp) >= yesterday;
                return prev || sinceYesterday;
            }, false)
        );
    }
}
